import { get, post } from '@/common/request';

const customerMap = new Map<string, string>([
  ['info', '/property/user/info'],
  ['module', '/property/modules'],
  ['config', '/tenant/init/config'],
  ['search', '/employee/search'],
  ['list', '/tenant/tntList']
]);

export default customerMap;

export interface CustomerResponse {
  id?:number;	// 员工id
  name?: string;	 // 姓名
  avatar?: null;	// 头像
  mobile?: string;	// 手机号
  tenant?: string;	// 租户名称
  email?:	null;	// 邮箱
  isAdmin?:	boolean;	// 是否是管理员
  departmentIds?:	number[];	// 部门id数组
  positionIds?:	number[];	// 岗位id数组
  roleIds?: number [];
  moduleList: Menu[];
}

export interface Menu {
  id?: number;	// 菜单id
  parent?: null; // 父级菜单
  name?: string	// 名称
  encode?: string	// 编码
  icon?: string	 // icon
  uri:	string	// 前端跳转地址
  sortNum?:	string	// 排序
  appId?:	number // 应用id
  children?: Menu[] // 子菜单列表
};



interface Config {
 id: number,
 placeCategoryTemplateId: number,
 spotCategoryTemplateId: number,
 placeEditNeedReview: number,
 spotEditNeedReview: number,
 spotOnlineNeedReview: number,
 spotOfflineNeedReview: number
}



export function getInfo(): Promise<CustomerResponse> {
  return get('/property/user/info', {}, { needHint: true });
}

export function getModule(): Promise<CustomerResponse> {
  return get('/property/modules', {}, { needHint: true, needCancel: false });
}

export function getConfig(): Promise<Config> {
  return post('/tenant/init/config', {}, { proxyApi: '/resserv', needHint: true });
}

// 员工搜索列表
export function userSearch(params:any): Promise<any> {
  return post('/employee/search', { ...params, size: 300 }, { proxyApi: '/mirage', needHint: true, needCancel: false });
}

export function getList(token, options: any) {
  return get('/tenant/tntList', { token }, { ...options, proxyApi: '/mirage', needHint: true });
}

/**
 * 用户列表
 * https://yapi.lanhanba.com/project/317/interface/api/33574
 */

export async function userList(params?: any) {
  return post('/employee/list', { ...params }, { proxyApi: '/mirage', needHint: true });
}

// 获取邀请成员链接
// https://yapi.lanhanba.com/project/319/interface/api/42685
export function getInviteLink(params?: any) {
  return get('/property/companies/invite', params, true);
}

// 获取公司下员工列表
// https://yapi.lanhanba.com/project/319/interface/api/42776
export function getCompanyMember(params?: any) {
  return get('/property/companies/member', params, true);
}
